import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, X, Check } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const empty = { question: "", answer: "", category: "Umum", order: 0, published: true };

const AdminFAQ = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/faqs").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, order: Number(form.order || 0) };
      if (editing === "new") await api.post("/faqs", payload);
      else await api.put(`/faqs/${editing}`, payload);
      toast.success("Berhasil disimpan"); setEditing(null); setForm(empty); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const del = async (id) => { if (window.confirm("Hapus?")) { await api.delete(`/faqs/${id}`); load(); } };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-display font-bold">FAQ</h1>
          <p className="mt-1 text-sm text-zinc-500">Kelola pertanyaan yang sering ditanyakan.</p>
        </div>
        <button onClick={() => { setEditing("new"); setForm(empty); }} data-testid="new-faq" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-maroon-800 text-white font-semibold">
          <Plus size={16} /> Tambah FAQ
        </button>
      </div>

      <div className="space-y-3">
        {items.map((f) => (
          <div key={f.id} className="bg-white p-5 rounded-2xl border border-zinc-200 flex items-start justify-between gap-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-maroon-700 font-bold">{f.category}</div>
              <div className="mt-2 font-display font-bold text-zinc-900">{f.question}</div>
              <div className="mt-1 text-sm text-zinc-600">{f.answer}</div>
            </div>
            <div className="flex gap-1 shrink-0">
              <button onClick={() => { setEditing(f.id); setForm(f); }} className="p-2 rounded-lg hover:bg-zinc-100"><Pencil size={14} /></button>
              <button onClick={() => del(f.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-600"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-10 text-center text-zinc-500">Belum ada FAQ.</div>}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-display font-bold">{editing === "new" ? "Tambah FAQ" : "Edit FAQ"}</h3>
              <button onClick={() => setEditing(null)} className="p-2 rounded-lg hover:bg-zinc-100"><X size={18} /></button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-zinc-800 mb-2">Pertanyaan *</label>
                <input value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} data-testid="faqf-q"
                  className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 outline-none" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-zinc-800 mb-2">Jawaban *</label>
                <textarea rows={4} value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} data-testid="faqf-a"
                  className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 outline-none" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-zinc-800 mb-2">Kategori</label>
                  <input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
                    className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-zinc-800 mb-2">Urutan</label>
                  <input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })}
                    className="w-full px-4 py-3 rounded-xl border border-zinc-200 outline-none" />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" checked={form.published} onChange={(e) => setForm({ ...form, published: e.target.checked })} id="fpub" />
                <label htmlFor="fpub" className="text-sm">Publish</label>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button onClick={() => setEditing(null)} className="px-5 py-2.5 rounded-full border font-semibold">Batal</button>
              <button onClick={save} data-testid="save-faq" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-maroon-800 text-white font-semibold"><Check size={16} /> Simpan</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminFAQ;
